import {Injectable, OnDestroy} from '@angular/core';
import {ActivatedRoute, NavigationExtras, Params, Router} from '@angular/router';
import {Observable, Subject} from 'rxjs';
import {map, shareReplay, takeUntil} from 'rxjs/operators';

@Injectable()
export class UrlService implements OnDestroy {
  private unsubscribe: Subject<void> = new Subject<void>();

  search: Subject<Params> = new Subject<Params>();
  search$!: Observable<{params: Params, allParams: Params}>;
  allowedParams!: string[];
  defaultValues: Params = {};

  constructor(
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.initStates();
    this.initSubscriptions();
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  private initStates(): void {
    this.search$ = this.search
      .pipe(
        takeUntil(this.unsubscribe),
        map((params: Params) => {
          if (!Array.isArray(this.allowedParams)) {
            return {
              params,
              allParams: {...this.defaultValues, ...params},
            };
          }
          const filteredParams: Params = {};
          for (const param of this.allowedParams) {
            if (params[param] !== undefined) {
              filteredParams[param] = params[param]
            }
          }
          return {
            params: filteredParams,
            allParams: {...this.defaultValues, ...filteredParams},
          };
        }),
        shareReplay(1)
      );
  }

  private initSubscriptions(): void {
    this.search$.subscribe(({params, allParams}: {params: Params, allParams: Params}): void => {
      // Actualiza los parametros de la url
      const extras: NavigationExtras = {
        relativeTo: this.route,
        queryParams: params,
      };
      this.router.navigate(['.'], extras);
    });
  }
}
